import { useState } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Button, Modal } from 'antd';
import IntlMessages from "../../../components/utility/intlMessages";
import CreateUserForm from './createUserForm';
import { Link } from "react-router-dom";

function ClinicDetailsUsers(props) {
  const [isModalVisible, setIsModalVisible] = useState(false);

  const showModal = () => {
    setIsModalVisible(true);
  };

  function handleCloseModal() {
    setIsModalVisible(false);
  };

  return (
    <Row style={{ marginTop: '25px' }} gutter={[16, 16]}>
      <Col span={24}>
        <Button onClick={showModal}>
          <IntlMessages id="clinicPage.clinicDetails.addNewUser" />
        </Button>
      </Col>
      <Col span={24}>
        <Row gutter={[16, 10]}>
          {props.users.map(user => (
            <Col span={24} key={user.id}>
              <Link
                to={`/Dashboard/userDetails/${user.id}`}>
                {`${user.lastName} ${user.firstName}`}
              </Link>
            </Col>
          ))}
        </Row>

        <Modal open={isModalVisible} footer={null} onCancel={handleCloseModal} destroyOnClose={true}>
          <CreateUserForm closeModal={handleCloseModal} />
        </Modal>

      </Col>
    </Row>
  )
}
ClinicDetailsUsers.propTypes = {
  users: PropTypes.array.isRequired,
};

ClinicDetailsUsers.defaultProps = {
  users: []
}

export default ClinicDetailsUsers;